import captainVerification from "./captainVerification.component";
import captainVerificationUrls from "./captainVerification.urls";
import CaptainVerificationTransforms from "./captainVerification.transforms";

const captainVerificationModule = angular
  .module("app.components.captainVerification", [])
  .component("captainVerificationPage", captainVerification)
  .service("CaptainVerificationTransforms", CaptainVerificationTransforms)
  .config(captainVerificationUrls);

export default captainVerificationModule;



// WEBPACK FOOTER //
// ./src/pages/captainVerification/captainVerification.module.js